import { createTheme, ThemeOptions } from '@mui/material/styles';

// assets

// project imports
import componentStyleOverrides from './comp-style-override';
import themePalette from './palette';
import themeTypography from './typography';

import { LayoutSlice } from '@/store/layout-slice';
import colors from '@/themes/colors';
import hgcColors from '@/themes/hgc-colors';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 * @param {string} client client identifier ('telma' or 'hgc')
 */

export const theme = (
    customization: LayoutSlice,
    client: 'telma' | 'hgc' = 'telma',
) => {
    const color = client === 'hgc' ? hgcColors : colors;

    const themeOption = {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        bgPinkDark: color.secondaryBgPinkDark,
        bgPinkHover: color.secondaryBgPinkHover,
        whiteTextPrimary: color.primaryLight,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization,
    };

    const themeOptions: ThemeOptions = {
        direction: 'ltr',
        //@ts-ignore
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px',
                },
            },
            //@ts-ignore
            drawer: {
                width: 250,
            },
        },
        //@ts-ignore
        typography: themeTypography(themeOption),
        borderRadius: 12,
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default theme;
